import { render, staticRenderFns } from "./loan-transaction-summary.vue?vue&type=template&id=5cf1f350&"
import script from "./loan-transaction-summary.vue?vue&type=script&lang=js&"
export * from "./loan-transaction-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports